export default function Molecule({ className = "" }) {
    return (
        <svg viewBox="0 0 220 220" fill="none" className={className} aria-hidden="true">
            <g stroke="currentColor" strokeWidth="1">
                {/* hexagon ring */}
                <line x1="110" y1="40" x2="162" y2="70" />
                <line x1="162" y1="70" x2="162" y2="130" />
                <line x1="162" y1="130" x2="110" y2="160" />
                <line x1="110" y1="160" x2="58" y2="130" />
                <line x1="58" y1="130" x2="58" y2="70" />
                <line x1="58" y1="70" x2="110" y2="40" />
                {/* satellites */}
                <line x1="110" y1="40" x2="110" y2="16" />
                <line x1="162" y1="130" x2="186" y2="144" />
                <line x1="58" y1="130" x2="34" y2="144" />
                {/* inner bond */}
                <line x1="74" y1="76" x2="110" y2="55" />
            </g>
            <g fill="currentColor">
                <circle cx="110" cy="40" r="4" />
                <circle cx="162" cy="70" r="3" />
                <circle cx="162" cy="130" r="3" />
                <circle cx="110" cy="160" r="4" />
                <circle cx="58" cy="130" r="3" />
                <circle cx="58" cy="70" r="3" />
                <circle cx="110" cy="14" r="2.5" />
                <circle cx="188" cy="146" r="2.5" />
                <circle cx="32" cy="146" r="2.5" />
            </g>
            <circle cx="110" cy="100" r="5" fill="#7A2230" />
        </svg>
    );
}
